export const DEFAULT_TRANSLATIONS = {
  quantity: 'Quantity',
};

export type Translations = Partial<typeof DEFAULT_TRANSLATIONS>;
